// Augment shop offer generation
import { RNG } from '../utils/rng';
import { AUGMENTS, AUGMENT_SHOP_ALLOWLIST } from './catalog';

/**
 * Generate augment shop offers using seeded RNG
 * 
 * @param {number} count - Number of offers to generate
 * @param {Object} options - Generation options
 * @param {number} options.money - Current money (used in seed)
 * @param {number} options.nonce - Reroll nonce (used in seed)
 * @param {number} options.roundNumber - Current round number (used in seed)
 * @param {number} options.augSeed - Session augment seed
 * @returns {Array<string>} Array of augment IDs
 */
export function generateAugmentShopOffers(count = 2, options = {}) {
  try {
    const { money = 0, nonce = 0, roundNumber = 1, augSeed = 0 } = options;
    
    let ids = AUGMENT_SHOP_ALLOWLIST.map((id) => (AUGMENTS[id] ? id : null)).filter(Boolean);
    if (ids.length < count) {
      ids = Object.keys(AUGMENTS || {}).filter(Boolean);
    }
    if (ids.length === 0) return [];
    
    // Fisher-Yates shuffle using seeded RNG (session seed + round + money + reroll nonce)
    const moneySeed = money || 0;
    const sessionSeed = (augSeed || 0) >>> 0;
    const roundPart = (((roundNumber & 0xffff) << 16) >>> 0);
    const moneyPart = (((moneySeed & 0xff) << 8) >>> 0);
    const noncePart = (nonce & 0xff) >>> 0;
    const seed = (sessionSeed ^ roundPart ^ moneyPart ^ noncePart) >>> 0;
    const rng = new RNG(seed);
    
    const arr = [...ids];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(rng.random() * (i + 1));
      const tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    
    const picks = [];
    const seen = new Set();
    for (let i = 0; i < arr.length && picks.length < count; i++) {
      const candidate = arr[i];
      if (!candidate || seen.has(candidate)) continue;
      seen.add(candidate);
      picks.push(candidate);
    }
    
    if (picks.length < count) {
      for (let i = 0; i < ids.length && picks.length < count; i++) {
        const candidate = ids[i];
        if (!candidate || seen.has(candidate)) continue;
        seen.add(candidate);
        picks.push(candidate);
      }
    }
    
    return picks;
  } catch (_) {
    return [];
  }
}






